import InvestmentDrawer from "./InvestmentDrawer"

export default InvestmentDrawer
